import {Navigate, useLocation} from 'react-router-dom'
import {useAuth} from '../modules/auth'

const AuthRedirect = () => {
  const {isLogOut} = useAuth()
  const location = useLocation()
  const intendedUrl = location.pathname + location.search

  if (isLogOut) {
    return <Navigate to='/auth' replace />
  }

  return <Navigate to='/auth' state={{from: intendedUrl}} />
}

export default AuthRedirect
